module.exports = __webpack_public_path__ + "static/img/ptGame2.163d2b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/head/ptGame2.png
// module id = wVJX
// module chunks = 3